import { Component, Input, OnDestroy, OnInit, Output, EventEmitter, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NavigationService } from '../../Service/Navigation.service';
import { LoadingService } from '../../Component/Loader/Loading.service';
import { CommonapiService } from '../../Service/Commonapi.service';
import { CustomerapiService } from '../../Service/Customerapi.service';
import { environment } from 'src/environments/environment';
import { Subscription } from 'rxjs';
import { LocationInfoService } from '../LocationInfo/LocationInfo.service';
import { CTVerifyComponent } from './CTVerify/CTVerify.component';
import * as moment from 'moment';
import { PlanCalendarService } from '../../../Core/PlanCalendar/PlanCalendar.service';
import { CTPlanMoveComponent } from './CTPlanMove/CTPlanMove.component';
import { CTPlanReasonComponent } from './CTPlanReason/CTPlanReason.component';
import { CTPlanRejectionComponent } from './CTPlanRejection/CTPlanRejection.component';
import { CTPlanCalendarComponent } from './CTPlanCalendar/CTPlanCalendar.component';
import { Common, logger } from '../../Utility/Common';
import { PlanAddService } from 'src/app/Module/Core/PlanAdd/PlanAdd.service';
//import { CDAppointmentComponent } from 'src/app/Module/Core/CustomerMeeting/CDAppointment/CDAppointment.component';
import { CDPlanAppointmentComponent } from './CDPlanAppointment/CDPlanAppointment.component';
import { CDAppointmentComponent } from 'src/app/Module/Core/CustomerMeeting/CDAppointment/CDAppointment.component';
import { CustomerDetailService } from 'src/app/Module/Core/CustomerDetail/CustomerDetail.service';
import { CTDigipinMapComponent } from './CTDigipinMap/CTDigipinMap.component';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
//import { MatDialogRef } from '@angular/material/dialog';
//import { PopupComponent } from '../../Component/Popup/Popup.component';

@Component({
  selector: 'app-CustomerTemplate',
  templateUrl: './CustomerTemplate.component.html'
})
export class CustomerTemplateComponent implements OnInit, OnDestroy {
  @Output() CallParent: EventEmitter<any> = new EventEmitter();
  @ViewChild(CTVerifyComponent) ctverify: CTVerifyComponent;
  @ViewChild(CTPlanMoveComponent) CTPlanMove: CTPlanMoveComponent;
  @ViewChild(CTPlanReasonComponent) CTPlanReason: CTPlanReasonComponent;
  @ViewChild(CTPlanRejectionComponent) CTPlanRejection: CTPlanRejectionComponent;
  @ViewChild(CTPlanCalendarComponent) ctplanCalendar: CTPlanCalendarComponent;


  @Input() data: any;
  @Input() edit_show: any = false;
  @Input() srcfrm: any;
  @Input() k: any;
  @Input() isBeats: any;
  @Input() beats_name: any;
  @Input() beats_id: any;

  // srcfrm:-
  // Dashboard 1
  // Popup (Map)  2
  // BusinessList 3
  // PlanCalendar 4
  // Search 5
  // CustomerDetail 6
  // CustomerNearby 7
  // planadd 8
  // beatDeatilList 9

  state: any = {
    location: "",
    digipinlocation: "",
    selectedObject: "",
    presentMonth: "",
    presentYear: "",
    preNextFlag: "",
    switch_type: { value: "3", iserr: false, err_txt: "" },
    reason: { value: "0", iserr: false, err_txt: "" },
    reasonComments: { value: "", iserr: false, err_txt: "" },
    movereason: { value: "0", iserr: false, err_txt: "" },
    movereasonComments: { value: "", iserr: false, err_txt: "" },
    rejectionreason: { value: "0", iserr: false, err_txt: "" },
    rejectionreasonComments: { value: "", iserr: false, err_txt: "" },
    fromDate: { value: "", iserr: false, err_txt: "" },
  }

  plancalendarstate: any = {
    customerid: { value: "", iserr: false, err_txt: "" },
    customername: { value: "", iserr: false, err_txt: "" },
    meetingdate: { value:  moment(new Date()).format("YYYY-MM-DD HH:mm:ss"), iserr: false, err_txt: "" },
  }
  googlemapstate: any = {
    placeID: "",
    latitude: "",
    longitude: ""
  }

  sellerstate: any = {
    customerid: { value: "0", iserr: false, err_txt: "" },
    seller: { value: [], iserr: false, err_txt: "" },
    existingseller: { value: "", iserr: false, err_txt: "" },
    sellerList :[],
    disabledItemIds :[],
  }

  categorytype;
  salesHospitaltype;
  showAddPlanCalendar:boolean=false;
  mainlatitude;
  mainlongitude;
  customerid = "";
  customerName = "";
  planid = "";
  //load_complete = false;
  dropdownList: any = [];
  meetingTypeList = [];
  dealList = [];
  selectedItems: any = [];
	planList:any = [];
  FormattedCalenderDate;
  isVerifiedFLG:boolean = false;
  divbeyondPopup = false;
  divsellerPopup = false;
  
    dropdownSettings: IDropdownSettings = {
    singleSelection: false,
    idField: 'customer_id',
    textField: 'customer_name',
    enableCheckAll: false,
    allowSearchFilter: true
  };

  constructor(private navigation: NavigationService, private route: ActivatedRoute, private loader: LoadingService,
    private router: Router, private Winfoapi: CommonapiService, private custapi: CustomerapiService,
    private locs: LocationInfoService, private planCalendarapi: PlanCalendarService,private planAddapi: PlanAddService,
  private customerdetailserviceapi: CustomerDetailService) { }
  //private dialogRef: MatDialogRef<PopupComponent>
  loc_Subscription: Subscription;
  _plan_along_status;
  ngOnInit() {
    console.log("srcfrm",this.srcfrm)
    this.isVerifiedFLG = this.Winfoapi.GetisVerified();
    //logger.sever_log('123' );
    this.loc_Subscription = this.locs.callback_info.subscribe((value) => {
      if (value.data && value.data.callbackid == "GoToCheckinPage" && value.data.data.customerID == this.data.customer_id) {
        this.GoToCheckinPage();
      }
    });
    this._plan_along_status=this.data.plan_along_status;
    this.salesHospitaltype = this.data.salesHospitaltype;
    this.mainlatitude = this.data.mainlatitude;
    this.mainlongitude = this.data.mainlongitude;
    //this.categorytype = this.Winfoapi.GetCategory();

    //alert(this.salesHospitaltype);
   // console.log("this._plan_along_status",this._plan_along_status)
   this.selectedItems = [
      // { item_id: 3, item_text: 'Pune' },
      // { item_id: 4, item_text: 'Navsari' }
    ];
  }
  GoToDetail(customerID, plantype) {

    if(customerID != null && plantype != "3")
    {
      this.Callparentfunc();
      this.router.navigate(['/user/customerdetail'], { queryParams: { customerid: customerID } });
      //this.dialogRef.close();
    }
  }

  getDirection(){
    console.log(" this.data", this.data)
    let selectedlat = this.data.latitude;
    let selectedlong = this.data.longitude;

    this.Winfoapi.GetDirection(selectedlat,selectedlong);

    //Common.showMap(selectedlat,selectedlong,"","");
  }

  async GoToCheckinPage() {


    // if(this.isVerifiedFLG && !this.data.is_verified ){
    //   if(this.srcfrm==6)
    //   this.Winfoapi.Toast_alert("Please verify the school to create meeting")
    //   else
    //   this.router.navigateByUrl('/user/customerdetail?customerid='+this.data.customer_id+'&show=verify', { replaceUrl: true })
    // }else{

    //this.dialogRef.close();
    let selectedlat = this.data.latitude;
    let selectedlong = this.data.longitude;
    let customerID = this.data.customer_id;
    let _location = await this.custapi.getLocation("GoToCheckinPage", { customerID: customerID });
    console.log("this.state.location", _location)
    if (_location.status == 1) {
      let _reTrigonometryDistanceMetert = this.custapi.VerifyDistance(customerID, selectedlat, selectedlong);
      let checkinDistance = environment.checkinDistance;
      if (_reTrigonometryDistanceMetert > checkinDistance) {
        this.Winfoapi.Toast_alert("Your location is more than " + checkinDistance + " meter", true);
        this.Callparentfunc();
        if(this.data.plan_id != undefined)
        {
          this.router.navigate(['/user/checkin'], { queryParams: { range: "1", src: "search", customerid: customerID, planid: this.data.plan_id } });
        }
        else{
          this.router.navigate(['/user/checkin'], { queryParams: { range: "1", src: "search", customerid: customerID } });
        }

      } else {
        this.Callparentfunc();
          if(this.data.plan_id != undefined)
          {
            this.router.navigate(['/user/checkin'], { queryParams: { range: "1", src: "search", customerid: customerID, planid: this.data.plan_id } });
          }
          else{
            this.router.navigate(['/user/checkin'], { queryParams: { range: "0", src: "search", customerid: customerID } });
          }
      }
    }
    //}


  }

  EditMeeting() {
    this.Callparentfunc();
    if (this.edit_show) {
      this.router.navigate(['/user/customer'], { queryParams: { customerid: this.data.customer_id, src: "detail" } });
    }
    else {
      this.router.navigate(['/user/editmeeting'], { queryParams: { customerid: this.data.customer_id, src: "detail" } });
    }
  }


  getAddress(obj) {
    let address = obj.meeting_address1;

    if (obj.meeting_address2 != null && obj.meeting_address2 != '' && obj.meeting_address2 != ',') {
      address += ', ' + obj.meeting_address2;
    }

    if (obj.meeting_area != null && obj.meeting_area != '') {
      address += ', ' + obj.meeting_area;
    }
    //landmark
    if (obj.meeting_city != null && obj.meeting_city != '') {
      address += ', ' + obj.meeting_city;
    }
    if (obj.meeting_state != null && obj.meeting_state != '') {
      address += ', ' + obj.meeting_state;
    }
    if (obj.meeting_country != null && obj.meeting_country != '') {
      address += ', ' + obj.meeting_country;
    }
    //address +=  ', ' + obj.city + ', ' + obj.billing_state + ', ' + obj.billing_country;

    return address;
  }

  Call(mobilenumber) {
    window.location.href = "tel:" + mobilenumber;
  }
  ngOnDestroy() {
    this._unsubscribe()
  }
  _unsubscribe() {
    this.loc_Subscription.unsubscribe();
  }


  Callparentfunc() {
    this.CallParent.emit();
  }


  CallVerified(obj) {
    this.ctverify.CallVerified(obj);
  }

  MainButtonEvent(obj) {
    this.state.fromDate.value = '';
    this.Move();
  }

  async Delete() {
    let obj=this.data;
    let formattedcalendardeleteDate = moment(obj.calendar_date_n).format( "YYYY-MM-DD");
    const endDate = new Date(formattedcalendardeleteDate);
    const daysExcludingSundays = this.calculateDaysExcludingSundays(new Date(), endDate);
    console.log('daysExcludingSundays', daysExcludingSundays);
    let workingday = 0;
    if (this.data.salesHospitaltype == "0" || this.data.salesHospitaltype == "1") {
      workingday = 15; //sales team
    }
    else if (this.data.salesHospitaltype == "2") {
      workingday = 21; //hospital team
    }
    if (workingday > (daysExcludingSundays)) {
      console.log('working day greater');
     await this.GetPlanResonDropdownListValues("2");
      this.CTPlanReason.Show(this.state);
    } else {
      console.log('numberOfDaysExcludingSundays greater');
      this.planDeleteReasonWithoutPopup();
    }
  }

  async Reject() {
     await this.GetPlanResonDropdownListValues("1"); // need to check the value
   // $('#divPlanRejectionReasonPopup').addClass('pop_active_card');
    this.CTPlanRejection.Show( this.state);
  }

  async Move() {
    //let obj=this.data;
      await this.GetPlanResonDropdownListValues("3"); // need to check the value
    this.state.movereason.iserr = false;
    this.state.movereason.err_txt = "";
    this.state.movereason.value = "0";
    this.state.movereasonComments.value = "";
    //$('#divPlanMoveCalendarPopup').addClass('pop_active_card');
    this.CTPlanMove.Show(this.data);
  }
  reasonList = []; movereasonList = []; rejectionreasonList = [];
  async GetPlanResonDropdownListValues(type) {
    var postdata = {      "deleteReject": type    };
    this.Winfoapi.loader.startLoading();
   await this.planCalendarapi.GetPlanResonDropdownListValues(postdata, false).then(data => {
      console.log("GetPlanResonDropdownListValues data", data)
      if (data && data != undefined && data != '[]') {
        this.CTPlanReason.reasonList = data.reasonList;
        this.CTPlanMove.movereasonList = data.reasonList;
        this.CTPlanRejection.rejectionreasonList = data.reasonList;
      }
      this.Winfoapi.loader.stopLoading();
    })
  }


  checkApproveRejectDate(obj) {
    const format2 = "YYYY-MM-DD";

    let currentDate = new Date();
    var formattedcurrentDate = moment(currentDate).format(format2);

    if (obj.calendar_date_n != '') {
      var formattedcalendarDate = moment(obj.calendar_date_n).format(format2);
    }
    else {
      return false;
    }

    if (formattedcalendarDate >= formattedcurrentDate) {
      return true;
    }
    else {
      return false;
    }

  }
selec_data_plan_along_status=0;
  ShowAcceptReject(type){
    console.log("this._plan_along_statu",this._plan_along_status);
    console.log(" this.data.plan_along_status", this.data.plan_along_status);
    setTimeout(() => {
      this.data.plan_along_status= this._plan_along_status;
    });

    if (type == "1") {
      this.Reject();
    }
    else if (type == "2") {
      this.Approve();
    }
  }
  SuccessRefreshold(data){
    console.log("SuccessAcceptRejectdata",data)
    if(data.status==1 && data.data){
      let _data=data.data.planListViewResponse[0];
      this.data=_data;
      this.data.salesHospitaltype = this.salesHospitaltype;
      this.data.mainlatitude = this.mainlatitude;
      this.data.mainlongitude = this.mainlongitude;
      this._plan_along_status=this.data.plan_along_status;
      console.log("SuccessAcceptRejectdata1",data)
      this.CallParent.emit({status:1,data:data.data.planCalendar});
    }
  }

  SuccessRefresh(data){
    console.log("SuccessAcceptRejectdata",data)
    if(data.status==1 && data.data){
      // let _data=data.data.planListViewResponse[0];
      // this.data=_data;
      // this.data.salesHospitaltype = this.salesHospitaltype;
      // this.data.mainlatitude = this.mainlatitude;
      // this.data.mainlongitude = this.mainlongitude;
      // this._plan_along_status=this.data.plan_along_status;
      console.log("SuccessAcceptRejectdata1",data)
      this.CallParent.emit({status:1,data:data.data});
    }
  }

  SuccessPlanCalendarRefresh(data){
    //alert(data);
    console.log("SuccessAcceptRejectdata",data)

  }

  // async ApproveReject(obj, index, type) {
  //   //alert(type);
  //   //alert(obj.plan_along_status);
  //   if (obj.plan_along_status != type && obj.plan_along_status != '0') {
  //     return false;
  //   }


  //   if ($('#' + index + '_0').length > 0 && $('#' + index + '_00').length > 0) {
  //     $('#' + index + '_0').remove();
  //     $('#' + index + '_00').remove();
  //   }

  //   if (type == "1") {
  //     this.Reject(obj);
  //   }
  //   else if (type == "2") {
  //     this.Approve(obj);
  //   }

  // }

  async Approve() {
    console.log('selected obj', this.data);
    const format1 = "YYYY-MM-DD";
    let calenderDate = moment(this.data.calendar_date).format(format1)
    

    let currentDate = new Date();
    const currentDateFormat1 = "YYYY-MM-DD";//"DD MMMM YYYY";
    var formattedCurrentDate = moment(currentDate).format(currentDateFormat1);
    var title = "\"" + this.data.customer_name + "\"" + " accompany has been approved by User";

        
    var postdata = {

      "planId": this.data.plan_id,
      "calendarDate": calenderDate,
      "customerId": this.data.customer_id,
      "movedToDate": "",
      "planAlongStatusSub": "1",
      "reasonId": "",
      "reason": "",
      "title": title,
      "data": "",
      "isRead": "",
      "url": environment.angularurl + "#/user/planlist",
      "create_user": this.data.is_create_user,
      "presentMonth": this.data.presentMonth,
      "presentYear": this.data.presentYear,
      "preNextFlag": this.data.preNextFlag,
      "latitude": this.data.mainlatitude+"",
      "longitude": this.data.mainlongitude+"",
      "startDate": this.data.startDate,
    }

    console.log("postdata", postdata);

    this.Winfoapi.loader.startLoading();
    this.planCalendarapi.PlanListEventGetUpdateV1(postdata, false).then(data => {
      if (data && data != undefined && data != '[]') {
        console.log('PlanListEventGetUpdateV1',data);
        if (data.planEventUpdateResponse.plan_id > 0) {      
          //this.SuccessRefresh({status:1,data:data.planListViewResponse[0]}); // old code    
          this.SuccessRefresh({status:1,data:data});
        }
      }
      this.Winfoapi.loader.stopLoading();
    })

  }
  async planDeleteReasonWithoutPopup() {
    this.state.reason.value = "0";
    this.state.reasonComments.value = "";
    let isvalid = true;
    if (isvalid) {
      console.log('selected obj', this.data);
      const format1 = "YYYY-MM-DD";
      let calenderDate = moment(this.data.calendar_date).format(format1)
      
      let currentDate = new Date();
      const currentDateFormat1 = "YYYY-MM-DD";//"DD MMMM YYYY";
      var formattedCurrentDate = moment(currentDate).format(currentDateFormat1);
      var title = "\"" + this.data.customer_name + "\"" + " plan has been removed by User";
      var postdata = {
        "planId": this.data.plan_id,
        "calendarDate": calenderDate,
        "customerId": this.data.customer_id,
        "movedToDate": "",
        "planAlongStatusSub": "3",
        "reasonId": this.state.reason.value,
        "reason": this.state.reasonComments.value,
        "title": title,
        "data": "",
        "isRead": "",
        "url": environment.angularurl + "#/user/planlist",
        "create_user": this.data.is_create_user,
        "presentMonth": this.data.presentMonth,
        "presentYear": this.data.presentYear,
        "preNextFlag": this.data.preNextFlag,
        "latitude": this.data.mainlatitude+"",
        "longitude": this.data.mainlongitude+"",
        "startDate": this.data.startDate,
      }
      console.log("postdata", postdata);
      this.Winfoapi.loader.startLoading();
      this.planCalendarapi.PlanListEventGetUpdateV1(postdata, false).then(data => {
        if (data && data != undefined && data != '[]') {
          console.log('PlanListEventGetUpdateV1',data);
          if (data.planEventUpdateResponse.plan_id > 0) {
            this.state.reasonComments.iserr = false;
            this.state.reasonComments.err_txt = "";
            //this.SuccessRefresh({status:1,data:data.planListViewResponse[0]}); //this is not old code
            this.SuccessRefresh({status:1,data:data});
          }
        }
        this.Winfoapi.loader.stopLoading();
      })
    }
  }

  calculateDaysExcludingSundays(startDate, endDate) {
    // Get the difference in days between the two dates.
    const daysDiff = Math.floor((endDate - startDate) / (1000 * 60 * 60 * 24));

    // Create an array to store the dates between the two dates.
    const dates = [];
    for (let i = 0; i <= daysDiff; i++) {
      dates.push(new Date(startDate.getTime() + (i * (1000 * 60 * 60 * 24))));
    }

    // Filter out the Sundays from the array.
    const filteredDates = dates.filter(date => date.getDay() !== 0);

    // Return the number of filtered dates.
    return filteredDates.length;
  }
  MeetingEnabledDisalbed(obj) {
    const format2 = "YYYY-MM-DD";

    let currentDate = new Date();
    var formattedcurrentDate = moment(currentDate).format(format2);

    if (obj.calendar_date_n != '') {
      var formattedcalendarDate = moment(obj.calendar_date_n).format(format2);
    }
    else {
      return false;
    }

    if (formattedcurrentDate == formattedcalendarDate) {
      return false;
    }
    else {
      return true;
    }

  }

  addGoogleCustomer(placeid)
  {
    this.Callparentfunc();
    this.router.navigate(['/user/customer'], { queryParams: { placeid: placeid } });
    //this.router.navigate(['/user/customer'], { queryParams: { placeid: placeid, customerid: obj.customer_id } });
  }

  mapGoogleCustomer(customername, meetingaddress1, placeid, lat, long)
  {
    //googlemapstate
    //this.Callparentfunc();
    // this.googlemapstate.placeID = placeid;
    // this.googlemapstate.latitude = lat;
    // this.googlemapstate.longitude = long;
    //this.GoogleMapCustomer.Show(this.googlemapstate);
    this.Callparentfunc();
    this.Winfoapi.ShowGMapCustomer({customername:customername,meetingaddress1:meetingaddress1, placeid:placeid,lat:lat,long:long, srcfrm:this.srcfrm})
  }


  EditPopup(isEdit, customerid)
  {
    this.Callparentfunc();
    if (this.Winfoapi.GetisEdit()) {
      this.router.navigate(['/user/customer'], { queryParams: { customerid: customerid, src: "detail" } });
    }
    else {
      this.router.navigate(['/user/editmeeting'], { queryParams: { customerid: customerid, src: "detail" } });
    }
  }

  AddPlanPopup(isAddPlan, customerid, customername)
  {
    this.showAddPlanCalendar = true;
    this.plancalendarstate.customerid.value = customerid;
    this.plancalendarstate.customername.value = customername;
    this.plancalendarstate.meetingdate.value = '';
    if (this.ctplanCalendar != undefined) {

        this.ctplanCalendar.Show(this.plancalendarstate);
    }
    // setTimeout(() => {
    //   Common._$("#txtdt").focus();
    // });
    return;

  }

  MeetingShow(){
    //let _cat_id=this.planCalendarapi.api.GetCategory();
    let _ret=true;
    if(this.isVerifiedFLG && !this.data.is_verified ){
      _ret=false;
    }
    return _ret;
  }

  //@ViewChild('cdAppointment') ch_app: CDPlanAppointmentComponent;
  @ViewChild('CDPlanAppointmentComponent') cdPlanAppointmentComponent: CDPlanAppointmentComponent;
  AddPlan(obj, _index) {
    //this.showAddPlanCalendar = false;
   // this.load_complete = false;
    this.customerid = obj.customer_id;
    this.customerName = obj.customer_name;
    var postdata = { "url": environment.apiurl + this.router.url, "CustomerId": obj.customer_id,
      "planId": this.planid };
    this.planAddapi.api.loader.startLoading();

    this.planAddapi.GetCustomerMeeting(postdata, false).then(data => {
      console.log("GetCheckinPurposeOfVisitFollowup data", data)
      if (data && data != undefined && data != '[]') {
        this.meetingTypeList = data.meetingTypeList;
        this.meetingTypeList.map((x)=>{ x.label=x.name,x.value=x.id})
        this.dealList = data.deal_json ? JSON.parse(data.deal_json) : [];
        this.dealList.map((x) => {
          if (x.deal_flow && x.deal_flow[0].current_stage)
            x.current_stage = x.deal_flow[0].current_stage
          else
            x.current_stage = 0;
        })
        this.dropdownList = [];
        data.addContactNames.map((y, index) => {
          this.dropdownList.push({ id: y.id, name: y.name, code: y.code, designation: y.designation });
        })
        this.selectedItems = this.dropdownList.filter((val) => val.code != "0");
       // this.load_complete = true;
        //this.ch_app.Show(_id, obj.id, _action_id, this.dealList);
        console.log(" Common.deal_stage", Common.deal_stage)
        console.log(" Common.dealList", this.dealList)
        this.cdPlanAppointmentComponent.Show(1, 2, 1, Common.deal_stage, this.dealList,this.dropdownList);
       // this.Show(1, 2, 1, Common.deal_stage, this.dealList);
        //this.showAddPlanCalendar = true;

        // if (this.cdPlanAppointmentComponent != undefined) {
        //     this.cdPlanAppointmentComponent.Show(1, 2, 1, Common.deal_stage, this.dealList);
        // }

      }
      this.planAddapi.api.loader.stopLoading();

    })
  }


  CallParentPlan($event) {
    console.log("$event", $event)
    console.log("$event.data", $event.data)
    //alert('childemit'+ $event.data);
    logger.sever_log($event.data);
    if($event.data != '')
    {


    this.planList = [];
    const format2 = "DD MMMM YYYY";
    this.FormattedCalenderDate = ""//;moment(this.querystringCalenderDate).format(format2) need to do
    let title = "";
    let url = environment.angularurl+"#/user/planlist";

        $event.data.map((y) => {
          console.log('y.id', y.id);
          this.FormattedCalenderDate = moment(y.data.When_format).format(format2)
          title = "create category meeting on " + this.FormattedCalenderDate;
          var planElements = {};

           planElements["customerid"] = this.customerid;
           planElements["id"] = y.id+"";
           planElements["when"] = y.data.When;
           planElements["personmet"] = y.data.personmet;
           planElements["meetingType"] = y.data.meetingType;
           planElements["area"] = y.data.area;
           planElements["comments"] = y.data.comments;
           planElements["title"] = title;
           planElements["url"] = url;
          this.planList.push(planElements);
        })

      console.log('this.planList', this.planList);



    var postdata = {

      "dealPlans" :  this.planList,
    }

    console.log("postdata",);
    logger.sever_log(postdata );
    //return false;

    this.Winfoapi.loader.startLoading();
    this.planAddapi.AddDealPlan(postdata, false).then(data => {

      if (data && data!= undefined && data != '[]') {

        if(data.plan_id > 0)
        {
          this.planAddapi.api.set_local_storage("sales_nearBybusinessdata", '');
          this.planAddapi.api.set_local_storage("sales_calendarcountlist", '');
          // this.businessList.map((x, index) => {

          //   // if(_index == index)
          //   // {
          //   //   // greencolor
          //   //   x.is_exists = "2";

          //   // }
          //    if(x.customer_id == this.customerid)
          //   {
          //     // greencolor
          //     x.is_exists = "2";

          //   }


          // })

          this.planAddapi.api.Toast_success(" \""+ this.customerName +  "\" is Added  ",true);

        }

      }

      this.Winfoapi.loader.stopLoading();
    })



  }


  }
  @ViewChild('CTDigipinMapComponent') CTDigipinMapComponent: CTDigipinMapComponent;
  async DigipinMap(customerID, latitude,longitude,is_digipin){
    this.CTDigipinMapComponent.Show(customerID, latitude, longitude, is_digipin, "");

  }

  CallParentDigipinMapSuccessRefresh(data){
        
    if(data.status==1 && data.data){
      this.data.is_digipin = data.data.isdigipinalreadyexist;
      this.data.latitude = data.data.latitude;
      this.data.longitude = data.data.longitude;
      console.log("SuccessAcceptRejectdata1",data)
      //this.CallParent.emit({status:1,data:data.data});
    }
  }

  async Checkbeyond(latitude,longitude)
  {    
    this.divbeyondPopup = false;
    this.state.digipinlocation = await this.custapi.getLocation();

    if (this.state.digipinlocation.status == 1) {

      setTimeout(async () => {

            var TrigonometryDistancekm =
              this.custapi.TrigonometryDistanceFromLatLonInKm(
                this.state.digipinlocation.lat +"", this.state.digipinlocation.long+"",
                latitude+"", longitude+"")
            
            var TrigonometryDistanceMeter = TrigonometryDistancekm * 1000;
            
            if (TrigonometryDistanceMeter > 3) {
              this.divbeyondPopup = true;
            }
            else
            {
              this.AddDIGIPIN();
            }
          
      });

    }

  }

  BeyandCancel() {
    this.divbeyondPopup = false;
  }

  BeyandYes() {
    this.AddDIGIPIN();
    this.divbeyondPopup = false;
  }

  async AddDIGIPIN() {
    
      var  _DIGIPIN = this.Get_DIGIPIN(this.state.digipinlocation.lat.toString(),this.state.digipinlocation.long.toString());
          
        var postdata = {
            "digiPin": _DIGIPIN + "",
            "customerCode":  this.data.customer_id + "",
          };        

        this.Winfoapi.loader.startLoading();
        await this.customerdetailserviceapi.addDigiPin(postdata, false).then(data => {
          
            if (data && data != undefined && data != '[]') {
              console.log("addDigiPin data", data)
                
              if (data.id > 0) {                  
                this.customerdetailserviceapi.api.Toast_success('DigiPin Successfully Added');
                this.data.is_digipin = true;
              }
              this.Winfoapi.loader.stopLoading();                  
            }
            else
            {
              this.Winfoapi.loader.stopLoading();                  
            }          

        })

  }

   Get_DIGIPIN(lat, lon) {
 
      var L = [
          ['F', 'C', '9', '8'],
          ['J', '3', '2', '7'],
          ['K', '4', '5', '6'],
          ['L', 'M', 'P', 'T']
      ];
      var vDIGIPIN = '';

      //variable for identification of row and column of the cells
      var row = 0;
      var column = 0;
      // Bounding Box Extent
      var MinLat = 2.5;
      var MaxLat = 38.50;
      var MinLon = 63.50;
      var MaxLon =
          99.50;
      var LatDivBy = 4;
      var LonDivBy = 4;
      var LatDivDeg = 0;
      var LonDivDeg = 0;
      if (lat < MinLat || lat > MaxLat) {
          alert('Latitude Out of range');
          return '';
      }
      if (lon < MinLon || lon > MaxLon) {
          alert('Longitude Out of range');
          return '';
      }
      for (let Lvl = 1; Lvl <= 10; Lvl++) {
          LatDivDeg = (MaxLat - MinLat) / LatDivBy;
          LonDivDeg = (MaxLon - MinLon) / LonDivBy;
          var NextLvlMaxLat = MaxLat;
          var NextLvlMinLat = MaxLat - LatDivDeg;
          var x = 0;
          for (x = 0; x < LatDivBy; x++) {

              if (lat >= NextLvlMinLat && lat < NextLvlMaxLat) {
                  row = x;
                  break;
              } else {
                  NextLvlMaxLat = NextLvlMinLat
                  NextLvlMinLat = NextLvlMaxLat - LatDivDeg;
              } 
          }

          var NextLvlMinLon = MinLon;
          var NextLvlMaxLon = MinLon + LonDivDeg;
          for (x = 0; x < LonDivBy; x++) {
              if (lon >= NextLvlMinLon && lon < NextLvlMaxLon) {
                  column = x;
                  break;
              } else if ((NextLvlMinLon + LonDivDeg) < MaxLon) {  
                  NextLvlMinLon = NextLvlMaxLon;
                  NextLvlMaxLon = NextLvlMinLon + LonDivDeg;
              } else {
                  column = x;
              }
          }

          if (Lvl == 1) {
              if (L[row][column] == "0") {
                  vDIGIPIN = "Out of Bound";
                  break;
              }
          }
          vDIGIPIN = vDIGIPIN + L[row][column];


          if (Lvl == 3 || Lvl == 6) {
              vDIGIPIN = vDIGIPIN + "-"
          }

  
          MinLat = NextLvlMinLat;
          MaxLat = NextLvlMaxLat;
          MinLon = NextLvlMinLon;
          MaxLon = NextLvlMaxLon;
      }
      return vDIGIPIN;
    }

    async AddSeller(customerID, meeting_city){

      this.sellerstate.sellerList = [];
      this.sellerstate.disabledItemIds = [];
      this.sellerstate.seller.value = [];
      this.sellerstate.customerid.value = customerID;
      this.sellerstate.existingseller.value = "";
      this.sellerstate.seller.iserr = false;
      this.sellerstate.seller.err_txt = "";
      let city = "";
      if (meeting_city != null && meeting_city != '' && meeting_city != undefined)
      {
        city = meeting_city.toLowerCase() + "";
      }
      

    var postdata = {
      customerID: customerID+'',
      city : city +'',
    };

    this.customerdetailserviceapi.api.loader.startLoading();

         this.customerdetailserviceapi.GetCDGetDistributor(postdata, false).then(data => {
         console.log("GetCDGetDistributor data",data)
         //undefined - bad request
         //[] - no records
         if (data && data!= undefined && data != '[]') {

            this.sellerstate.sellerList = data.cdDistributorList;            
              
              if(this.sellerstate.sellerList.length > 0)
              {
                if (data.cdexistingdistributor != '[]' && data.cdexistingdistributor.length > 0)
                {
                  if (data.cdexistingdistributor[0].distributor_sub_distributor_list != null
                    && data.cdexistingdistributor[0].distributor_sub_distributor_list != '' 
                    && data.cdexistingdistributor[0].distributor_sub_distributor_list != undefined)
                  {
                    this.sellerstate.existingseller.value = data.cdexistingdistributor[0].distributor_sub_distributor_list;
                  }
                }
                this.preSelectSeller();
                this.divsellerPopup = true;
              }       
         
         }

         this.customerdetailserviceapi.api.loader.stopLoading();      

     });
      
    }

    preSelectSeller()
    {
      if(this.sellerstate.existingseller.value != '' && this.sellerstate.existingseller.value != null)
      {

        var items1: any = [];
        var sellertemparray = new Array();
        sellertemparray = this.sellerstate.existingseller.value.split(",");

        if(sellertemparray.length > 0)
        {
            //let array3 = [17238, 17258];
            let array3 = sellertemparray;

            array3.map((x) => { 

            let _p1 = this.sellerstate.sellerList.filter((y) => { return y.customer_id == x });
            
                _p1.map((y) => { 

                  var currentSellerElements = {};
                  currentSellerElements["customer_id"] = y.customer_id;
                  currentSellerElements["customer_name"] = y.customer_name;      
                  items1.push(currentSellerElements);

                   if(y.has_order)
                  {
                    this.sellerstate.disabledItemIds.push(y.customer_id);

                    let objIndex = -1;
                    objIndex = this.sellerstate.sellerList.findIndex(obj => obj.customer_id === y.customer_id);
                    if (objIndex !== -1) {
                      // Update the property of the matched item directly
                      this.sellerstate.sellerList[objIndex].isDisabled = true;
                     }                    
                  }
                
                })
            })

          this.sellerstate.seller.value = items1;

        }      

      }       

    }

    SellerCancel() {
      this.divsellerPopup = false;
    }

    SellerYes() {
    
    let isvalid = true;
     let _seller_value="";

    if(this.sellerstate.seller?.value?.length>0)
      _seller_value= this.sellerstate.seller.value?.map((y, index) => { return y.customer_id; }).join(",");

  
    if (_seller_value == "") {

      this.sellerstate.seller.iserr = true;
      this.sellerstate.seller.err_txt = "Select distributor";
      isvalid = false;
    }else
    {
      this.sellerstate.seller.iserr = false;
      this.sellerstate.seller.err_txt = "";
    }

    if (isvalid) {
    
        var postdata = {
          customerID: this.sellerstate.customerid.value+'',      
          distributorids: _seller_value
          
        };

        this.customerdetailserviceapi.api.loader.startLoading();

            this.customerdetailserviceapi.CDSaveDistributor(postdata, false).then(data => {
            console.log("CDSaveDistributor data",data)
            //undefined - bad request
            //[] - no records
            if (data && data!= undefined && data != '[]') {

                if (data.cdDistributorDetailList != '[]' && data.cdDistributorDetailList.length > 0)
                {
                  this.CallParent.emit({status:1,data:data.cdDistributorDetailList});
                }         
            
            }

            this.customerdetailserviceapi.api.loader.stopLoading();

        });   
          this.divsellerPopup = false;
        }
    }

     OnItemDeSelect(item: any) {
      
      if (this.sellerstate.disabledItemIds.includes(item.customer_id)) {
        // Add it back immediately
        this.sellerstate.seller.value = [...this.sellerstate.seller.value, item];
        //alert(JSON.stringify(this.sellerstate.disabledItemIds));
      }

  }
  
  
  onItemSelect(item: any) {
      this.sellerstate.seller.iserr = false;
      this.sellerstate.seller.err_txt = "";
  }

  classificationCategoryClass(obj)
  {    

    if(obj.classification_category == null || obj.classification_category == "" || obj.classification_category == "undefined")
    {
      return "";
    }
    else if(obj.classification_category.toLowerCase() == "unknown")
    {
      return "";
    }
    else if(obj.classification_category.toLowerCase() == "a" || obj.classification_category.toLowerCase() == "an")
    {
      return "ptc_a";
    }
    else if(obj.classification_category.toLowerCase() == "b" || obj.classification_category.toLowerCase() == "bn")
    {
      return "ptc_b";
    }
    else if(obj.classification_category.toLowerCase() == "c" || obj.classification_category.toLowerCase() == "cn")
    {
      return "ptc_c";
    }
    else
    {
      return "";
    }
    
  }

}
